/**
 * Спиннер-индикатор загрузки.
 * Анимированный SVG-круг с настраиваемым размером и цветом.
 */

interface LoaderProps {
	/** Размер в пикселях (ширина и высота SVG) */
	size?: number;
	/** Цвет обводки круга */
	color?: string;
	className?: string;
}

export function Loader({ size = 20, color = 'currentColor', className }: LoaderProps) {
	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			style={{ animation: 'spin 0.8s linear infinite' }}
		>
			{/* Фоновый круг — полупрозрачный */}
			<circle cx="12" cy="12" r="10" stroke={color} strokeWidth="3" opacity="0.2" />
			{/* Основная дуга — видимая часть спиннера */}
			<path d="M12 2a10 10 0 0 1 10 10" stroke={color} strokeWidth="3" strokeLinecap="round" />
			<style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
		</svg>
	);
}
